@if (loadingProduct()) {
  <app-loading />
}

@if (errorProduct() && !loadingProduct()) {
  <app-error-data [title]="errorProduct()" />
}

@if (!loadingProduct() && !errorProduct()) {
  <div class="flex flex-col gap-8">
    <div>
      <div class="flex h-full w-full flex-wrap items-start justify-center gap-6">
        <div class="relative h-[19rem] flex-2/3">
          <app-image-carousel
            type="customer-product"
            [profileImage]="productImageUrl()"
            [extraImages]="productImages()"
            [isLoading]="loadingProduct()" />

          @if (remainingQuantity() != null) {
            <div class="absolute start-3 top-3 z-10">
              @if (isLimitReached()) {
                <span
                  class="inline-flex items-center gap-1.5 rounded-full border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-semibold whitespace-nowrap text-red-700">
                  <app-limit-reached-icon size="14" />
                  {{ isArabic() ? "تم الوصول للحد المسموح" : "Limit Reached" }}
                </span>
              } @else {
                <span
                  class="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold whitespace-nowrap text-amber-800">
                  <app-remaining-quantity-icon size="14" />
                  {{ isArabic() ? "متبقي " + remainingQuantity() : remainingQuantity() + " Remaining" }}
                </span>
              }
            </div>
          }
        </div>
        <div class="flex-1/4">
          <app-product-details-card
            [productId]="productId()"
            [productTitle]="isArabic() ? productData()?.titleAr || 'غير محدد' : productData()?.titleEn || 'Not Set'"
            [mfgCompany]="isArabic() ? productData()?.mfgCompany?.titleAr : productData()?.mfgCompany?.titleEn"
            [pharmacyPrice]="productData()?.businessPrice"
            [pharmacyDiscount]="productData()?.businessPriceDiscountPercentage"
            [peoplePrice]="productData()?.customerPrice"
            [unitPrice]="+(productData()?.customerPrice || 0)"
            [remainingQuantity]="remainingQuantity()" />
        </div>
      </div>
    </div>

    <app-product-information-card
      [category]="isArabic() ? productData()?.category?.titleAr : productData()?.titleEn"
      [subCategory]="isArabic() ? productData()?.subCategory?.titleAr : productData()?.subCategory?.titleEn"
      [mfgCompany]="isArabic() ? productData()?.mfgCompany?.titleAr : productData()?.mfgCompany?.titleEn"
      [batchNumber]="productData()?.batchNumber"
      [description]="isArabic() ? productData()?.descriptionAr : productData()?.descriptionEn"
      [mfgDate]="productData()?.mfgDate"
      [expDate]="productData()?.expDate"
      [peoplePrice]="productData()?.customerPrice"
      [pharmacyPrice]="productData()?.businessPrice"
      [businessPriceDiscountPercentage]="productData()?.businessPriceDiscountPercentage" />
  </div>
}
